import api from '@/services/axiosApi'
import { useConfigStore } from '@/stores/configStore'
import { storeToRefs } from 'pinia'

export interface VariantMetrics {
  variantId: string
  exposures: number
  conversions: number
  conversionRate: number
}

export interface SplitTestMetrics {
  splitTestPid: string
  metrics: Record<string, VariantMetrics>
  totals?: {
    exposures: number
    conversions: number
    conversionRate: number
  }
}

export const splitTestService = {
  async getMetrics(pid: string): Promise<SplitTestMetrics> {
    const configStore = useConfigStore()
    const { currentTeamPid } = storeToRefs(configStore)
    const { data } = await api.get<SplitTestMetrics>(`/api/${currentTeamPid.value}/splitTests/${pid}/metrics`)
    return data
  }
}